module.exports = {"120117100":"芦台镇","120117102":"宁河镇","120117103":"苗庄镇","120117104":"丰台镇","120117105":"岳龙镇","120117106":"板桥镇","120117107":"潘庄镇","120117109":"造甲城镇","120117110":"七里海镇","120117111":"大北涧沽镇","120117112":"东棘坨镇","120117113":"北淮淀镇","120117114":"俵口镇","120117115":"廉庄镇","120117400":"宁河区贸易开发区","120117401":"宁河区经济开发区","120117402":"天津未来科技城开发区片区","120117403":"天津未来科技城滨海高新区片区","120117451":"天津未来科技城宁河片区现代产业区组团","120117452":"天津未来科技城宁河片区潘庄工业区组团","120117453":"天津未来科技城宁河片区北淮淀组团","120117500":"潘庄农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120117.json
// module id = 53
// module chunks = 0